module.exports = __webpack_public_path__ + "img/logo.84559554.png";